module.exports = __webpack_public_path__ + "static/media/arizona-logo.85ca58ba.svg";